import { useState, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import MapComponent from "./MapComponent";

function NeubauProjekteTabs({ projectsData, listColor = "blue", defaultActiveTab = "alle", isLoading }) {
    const [tabs, setTabs] = useState(["alle"]);

    const staticItem = {
        id: "static-zentrum-toedi",
        slug: "https://www.toedi-horgen.ch/",
        Page_Template: "Neubauprojekte",
        Page_Titel: "Zentrum Tödi, Horgen",
        Beitrags_Miniaturbild: {
            url: "/uploads/Toedi_Bauphase_2026_05_Foto_Gataric_088_e93de8a07f.jpg", // or your image path
        },
        Projekt_Info: {
            Etappe: "2 Etappe",
            Haus: "Haus A, B & TG",
            Pflegezentrum: "Pflegezentrum",
        },
        static: true
    };

    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hoveredId, setHoveredId] = useState(null);

    const mouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();

        setPosition({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    const [active, setActive] = useState("list");
    const [activeTab, setActiveTab] = useState("alle");
    const [activeSubTab, setActiveSubTab] = useState("alle");

    useEffect(() => {
        setActiveTab(defaultActiveTab.toLocaleLowerCase());
    }, [defaultActiveTab]);

    // 👉 split category + subcategory from same field
    const getCategoryData = (item) => {
        const categories =
            item?.neubauprojekte_kategoriens?.map((cat) => {
                // const fullTitle = cat?.Titel?.toLowerCase()?.trim() || "";
                const fullTitle = cat?.Titel?.trim() || "";

                const [category, subcategory] = fullTitle
                    .split(" - ")
                    .map((v) => v?.trim());

                return {
                    category,
                    subcategory,
                    fullTitle,
                };
            }) || [];

        return categories;
    };

    // 👉 Categories
    const categories = useMemo(() => {

        // 👉 fixed order
        const categoryOrder = [
            "alle",
            "sanierungen",
            "neubau",
            "pionierprojekte",
            "nachhaltigkeit & innovation",
            "gebiet",
        ];

        // 👉 get all categories
        const allCategories = [
            ...new Set(
                projectsData
                    ?.flatMap((item) =>
                        getCategoryData(item)?.map(
                            (cat) => cat.category
                        )
                    )
                    ?.filter(Boolean)
            ),
        ];

        // 👉 sort categories
        const sortedCategories = allCategories.sort(
            (a, b) => {

                const indexA = categoryOrder.indexOf(a?.toLowerCase());
                const indexB = categoryOrder.indexOf(b?.toLowerCase());

                // 👉 unknown categories go last
                const safeIndexA =
                    indexA === -1
                        ? Number.MAX_SAFE_INTEGER
                        : indexA;

                const safeIndexB =
                    indexB === -1
                        ? Number.MAX_SAFE_INTEGER
                        : indexB;

                return safeIndexA - safeIndexB;
            }
        );

        return [
            "alle",
            ...sortedCategories.filter(
                (cat) => cat?.toLowerCase() !== "alle"
            ),
        ];

    }, [projectsData]);

    // const categories = useMemo(() => {
    //     return [
    //         "alle",
    //         ...new Set(
    //             projectsData
    //                 ?.flatMap((item) =>
    //                     getCategoryData(item)?.map(
    //                         (cat) => cat.category
    //                     )
    //                 )
    //                 ?.filter(Boolean)
    //         ),
    //     ];
    // }, [projectsData]);

    // 👉 Sub Categories
    const subCategories = useMemo(() => {
        // if (activeTab === "alle") return [];

        const filteredPosts = projectsData?.filter((item) =>
            getCategoryData(item)?.some(
                (cat) => cat.category?.toLowerCase() === activeTab?.toLowerCase()
            )
        );

        return [
            // "alle",
            ...new Set(
                filteredPosts
                    ?.flatMap((item) =>
                        getCategoryData(item)
                            ?.filter(
                                (cat) =>
                                    cat.category?.toLowerCase() === activeTab?.toLowerCase()
                            )
                            ?.map((cat) => cat.subcategory)
                    )
                    ?.filter(Boolean)
            ),
        ];
    }, [activeTab, projectsData]);

    // useEffect(() => {
    //     console.log("Sub Categories for", activeTab, subCategories);
    //     setActiveSubTab(subCategories[0]);
    // }, [activeTab]);

    useEffect(() => {
        setActiveSubTab(
            subCategories.length ? subCategories[0] : "alle"
        );
    }, [subCategories]);

    // 👉 Filtered Data
    // 👉 Filtered Data
    // const filteredData = useMemo(() => {
    //     // 👉 ALL
    //     // if (activeTab === "alle") {
    //     //     return [...(projectsData || [])];
    //     // }
    //     if (activeTab === "alle") {
    //         return (projectsData || []).filter(
    //             item => item.Page_Template?.toLowerCase() !== "sanierungen"
    //         );
    //     }

    //     // 👉 CATEGORY + SUBCATEGORY FILTER
    //     return projectsData
    //         ?.filter((item) => {
    //             const categories = getCategoryData(item);

    //             // 👉 category match
    //             const hasCategory = categories?.some(
    //                 (cat) => cat.category?.toLowerCase() === activeTab?.toLowerCase()
    //             );

    //             if (!hasCategory) return false;

    //             // 👉 subcategory match
    //             if (activeSubTab === "alle") return true;

    //             return categories?.some(
    //                 (cat) =>
    //                     cat.category?.toLowerCase() === activeTab?.toLowerCase() &&
    //                     cat.subcategory?.toLowerCase() === activeSubTab?.toLowerCase()
    //             );
    //         });
    // }, [
    //     activeTab,
    //     activeSubTab,
    //     projectsData,
    // ]);


    const filteredData = useMemo(() => {
        let data = [];

        // 👉 ALL
        if (activeTab === "alle") {
            data = (projectsData || []).filter(
                (item) => item.Page_Template?.toLowerCase() !== "sanierungen"
            );
        } else {
            // 👉 CATEGORY + SUBCATEGORY FILTER
            data = (projectsData || []).filter((item) => {
                const categories = getCategoryData(item);

                const hasCategory = categories?.some(
                    (cat) => cat.category?.toLowerCase() === activeTab?.toLowerCase()
                );

                if (!hasCategory) return false;

                if (activeSubTab === "alle") return true;

                return categories?.some(
                    (cat) =>
                        cat.category?.toLowerCase() === activeTab?.toLowerCase() &&
                        cat.subcategory?.toLowerCase() === activeSubTab?.toLowerCase()
                );
            });
        }

        // 👉 Add static item only for Neubau / Alle
        if (
            activeTab === "alle" ||
            activeTab?.toLowerCase() === "neubau"
        ) {
            data = [...data, staticItem];
        }

        return data;
    }, [
        activeTab,
        activeSubTab,
        projectsData,
    ]);

    // 👉 Equal Heights
    useEffect(() => {
        const equalHeight = () => {
            const headings = document.querySelectorAll(
                ".tab-content .item_inner h3"
            );

            let maxH4 = 0;

            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });

            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            const paragraphs = document.querySelectorAll(
                ".tab-content .item_inner p"
            );

            let maxP = 0;

            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });

            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        setTimeout(equalHeight, 300);

        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    useEffect(() => {
        const equalHeight = () => {
            const headings = document.querySelectorAll(
                ".tab-content .item_inner h3"
            );

            let maxH4 = 0;

            headings.forEach((el) => {
                el.style.height = "auto";
                maxH4 = Math.max(maxH4, el.offsetHeight);
            });

            headings.forEach((el) => {
                el.style.height = maxH4 + "px";
            });

            const paragraphs = document.querySelectorAll(
                ".tab-content .item_inner p"
            );

            let maxP = 0;

            paragraphs.forEach((el) => {
                el.style.height = "auto";
                maxP = Math.max(maxP, el.offsetHeight);
            });

            paragraphs.forEach((el) => {
                el.style.height = maxP + "px";
            });
        };

        setTimeout(equalHeight, 300);

        window.addEventListener("resize", equalHeight);

        return () => {
            window.removeEventListener("resize", equalHeight);
        };
    }, []);

    const truncateBlocks = (blocks, maxLength = 120) => {
        if (!blocks) return "";

        let text = "";

        for (let block of blocks) {
            if (block.children) {
                for (let child of block.children) {
                    text += child.text;

                    if (text.length >= maxLength) {
                        return text.slice(0, maxLength) + "...";
                    }
                }
            }
        }

        return text;
    };

    const [visibleCount, setVisibleCount] = useState(9);

    useEffect(() => {
        setVisibleCount(9);
    }, [activeTab]);

    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        if (params.get("id") === "projekte") {
            setTimeout(() => {
                const element = document.getElementById("projekte");

                if (element) {
                    const top =
                        element.getBoundingClientRect().top + window.pageYOffset;

                    element.scrollIntoView({
                        top,
                        behavior: "smooth",
                        // block: "start",
                    });
                }
            }, 1000);
        }
    }, [location.search, isLoading]);

    return (
        <div className="tab_wrapper" id="projekte">
            {/* Nav Tabs */}
            <div className='tabs-view-flex'>
                <div className="custom-pill d-flex align-items-center">
                    <button className={`pill-btn ${active === "list" ? "active" : ""}`} onClick={() => setActive("list")}><span className="me-2"><img src={`images/view-list${listColor === "orange" ? "" : "-blue"}.svg`} alt="#" /></span> Liste</button>
                    <button className={`pill-btn ${active === "map" ? "active" : ""}`} onClick={() => setActive("map")}><span className="me-2"><img src={`images/view-grid${listColor === "orange" ? "" : "-blue"}.svg`} alt="#" /></span>Karte</button>
                </div>
                <ul className="nav nav-tabs">
                    {categories.map((cat) => (
                        <li key={cat} className="nav-item">
                            <button
                                className={`nav-link ${activeTab?.toLowerCase() === cat?.toLowerCase() ? "active" : ""
                                    }`}
                                onClick={() => setActiveTab(cat)}
                            >
                                {/* {cat.charAt(0).toUpperCase() + cat.slice(1)} */}
                                {cat
                                    .split(" ")
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                    .join(" ")}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Tab Content */}
            <div className="tab-content mt-3">
                <div className="tab-pane active">
                    <div className="tab-filter-data-tabs">
                        {activeTab !== "alle" && <ul className="nav nav-tabs">
                            {subCategories.filter((subCat) => subCat.toLowerCase() !== "alle").map((subCat) => (
                                <li className="nav-item" key={subCat}>
                                    <button
                                        className={`nav-link ${activeSubTab === subCat ? "active" : ""
                                            }`}
                                        onClick={() => setActiveSubTab(subCat)}
                                    >
                                        {/* {subCat.charAt(0).toUpperCase() + subCat.slice(1)} */}
                                        {/* {subCat
                                            .split(" ")
                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                            .join(" ")} */}
                                        {/* {
                                            subCat?.toLowerCase() === "rechtes seeufer" || subCat?.toLowerCase() === "linkes seeufer"
                                                ? subCat
                                                    .split(" ")
                                                    .map((word, index) =>
                                                        index === 0
                                                            ? word.charAt(0).toLowerCase() + word.slice(1).toLowerCase()
                                                            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                                                    )
                                                    .join(" ")
                                                : subCat
                                                    .split(" ")
                                                    .map(
                                                        word =>
                                                            word.charAt(0).toUpperCase() +
                                                            word.slice(1).toLowerCase()
                                                    )
                                                    .join(" ")
                                        } */}
                                        {subCat}
                                    </button>
                                </li>
                            ))}
                        </ul>}
                    </div>
                    <div className="tab-content mt-3">
                        <div className="tab-pane active">
                            <div className={`list-view ${active === "list" ? "d-block" : "d-none"}`}>
                                <div className="row new-design-columns sanierungen_list_wrapper">
                                    {filteredData?.slice(0, visibleCount)?.map((item, index) => {
                                        const banner = item?.Bannerbereich?.[0];
                                        const module = item?.Modul?.[0];

                                        return (
                                            <div
                                                className="col-sm-6 col-lg-4 col-item my-3 my-lg-4"
                                                key={item.id}
                                                style={{
                                                    borderLeft: index % 3 === 0 ? "0" : "1px solid #ddd",
                                                }}
                                            >
                                                {!item?.static ? (
                                                    <Link to={`/${item?.Page_Template ? item?.Page_Template?.toLowerCase() : 'neubauprojekte'}/${item?.slug}`} className="item_inner">
                                                        <figure className="mb-0">
                                                            <div
                                                                className={`fig-image ${hoveredId === item.id ? "hide_cursor" : ""
                                                                    }`}
                                                                onMouseMove={mouseMove}
                                                                onMouseEnter={() => setHoveredId(item.id)}
                                                                onMouseLeave={() => setHoveredId(null)}
                                                            >
                                                                <img src={`https://backend.bgzurlinden.ch${item?.Beitrags_Miniaturbild?.url || banner?.Bild?.url}`} alt="#" className="w-100" />
                                                                <div className='img_tags'>
                                                                    {item?.sanierungen_tags?.map((tag, i) => (
                                                                        <span key={i} className={`bg-${tag?.Farbe?.split(" ")[0]}`}>{tag?.Titel}</span>
                                                                    ))}
                                                                </div>

                                                                {hoveredId === item.id && (
                                                                    <div
                                                                        className="image_cursor"
                                                                        style={{
                                                                            left: `${position.x}px`,
                                                                            top: `${position.y}px`,
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={`/images/cursor${listColor === "blue" ? '-blue' : ''}.png`}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                )}
                                                                {item?.Page_Template?.toLowerCase() !== 'sanierungen' && item?.Projekt_Info && <h4 className="text-theme fw-700 fs-30 text-uppercase">
                                                                    <span style={{ color: `var(--${listColor})` }}>
                                                                        {item?.Projekt_Info?.Kreis && `Kreis ${item?.Projekt_Info?.Kreis}`}
                                                                        {item?.Projekt_Info?.Kreis && <br />}
                                                                        {item?.Projekt_Info?.Wohnungen && `${item?.Projekt_Info?.Wohnungen} Wohnungen`}
                                                                        {item?.Projekt_Info?.Wohnungen && <br />}
                                                                        {item?.Projekt_Info?.Gebaeude && `${item?.Projekt_Info?.Gebaeude} Gebäude`}
                                                                        {/* {item?.Ubersichtstext} */}
                                                                    </span>
                                                                </h4>}
                                                            </div>
                                                            <figcaption>
                                                                <h3 className="text-darkgrey fw-550 fs-30">{item?.Page_Titel}</h3>
                                                                {/* {banner?.Beschreibung && (
                                                                <p>{truncateBlocks(banner.Beschreibung, 90)}</p>
                                                            )} */}
                                                                {item?.Page_Template?.toLowerCase() === 'sanierungen' && item?.Ubersichtstext}
                                                            </figcaption>
                                                        </figure>
                                                    </Link>
                                                ) : (
                                                    <a href={`${item?.slug}`} target="_blank" className="item_inner">
                                                        <figure className="mb-0">
                                                            <div
                                                                className={`fig-image ${hoveredId === item.id ? "hide_cursor" : ""
                                                                    }`}
                                                                onMouseMove={mouseMove}
                                                                onMouseEnter={() => setHoveredId(item.id)}
                                                                onMouseLeave={() => setHoveredId(null)}
                                                            >
                                                                <img src={`https://backend.bgzurlinden.ch${item?.Beitrags_Miniaturbild?.url || banner?.Bild?.url}`} alt="#" className="w-100" />
                                                                <div className='img_tags'>
                                                                    {item?.sanierungen_tags?.map((tag, i) => (
                                                                        <span key={i} className={`bg-${tag?.Farbe?.split(" ")[0]}`}>{tag?.Titel}</span>
                                                                    ))}
                                                                </div>

                                                                {hoveredId === item.id && (
                                                                    <div
                                                                        className="image_cursor"
                                                                        style={{
                                                                            left: `${position.x}px`,
                                                                            top: `${position.y}px`,
                                                                            width: '100px',
                                                                            height: '100px'
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={`/images/im-bau${listColor === "blue" ? '-blue' : '-orange'}.svg`}
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                )}
                                                                {item?.Page_Template?.toLowerCase() !== 'sanierungen' && item?.Projekt_Info && <h4 className="text-theme fw-700 fs-30 text-uppercase">
                                                                    {!item?.static ? (
                                                                        <span style={{ color: `var(--${listColor})` }}>
                                                                            {item?.Projekt_Info?.Kreis && `Kreis ${item?.Projekt_Info?.Kreis}`}
                                                                            {item?.Projekt_Info?.Kreis && <br />}
                                                                            {item?.Projekt_Info?.Wohnungen && `${item?.Projekt_Info?.Wohnungen} Wohnungen`}
                                                                            {item?.Projekt_Info?.Wohnungen && <br />}
                                                                            {item?.Projekt_Info?.Gebaeude && `${item?.Projekt_Info?.Gebaeude} Gebäude`}
                                                                            {/* {item?.Ubersichtstext} */}
                                                                        </span>
                                                                    ) : (
                                                                        <span style={{ color: `var(--${listColor})` }}>
                                                                            2 Etappe
                                                                            <br />
                                                                            Haus A, B & TG
                                                                            <br />
                                                                            Pflegezentrum
                                                                        </span>
                                                                    )}
                                                                </h4>}
                                                            </div>
                                                            <figcaption>
                                                                <h3 className="text-darkgrey fw-550 fs-30">{item?.Page_Titel}</h3>
                                                                {/* {banner?.Beschreibung && (
                                                                <p>{truncateBlocks(banner.Beschreibung, 90)}</p>
                                                            )} */}
                                                                {item?.Page_Template?.toLowerCase() === 'sanierungen' && item?.Ubersichtstext}
                                                            </figcaption>
                                                        </figure>
                                                    </a>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                {visibleCount < filteredData?.length && (
                                    <div className='btn-container d-flex justify-content-center mt-4'>
                                        <button
                                            className='button border-btn btn-theme-color'
                                            onClick={() => setVisibleCount((prev) => prev + 9)}
                                        >
                                            mehr
                                        </button>
                                    </div>
                                )}
                            </div>
                            <div className={`map-view ${active === "map" ? "d-block" : "d-none"}`}>
                                <div className="map-view-wrapper mt-3 mt-lg-4">
                                    {/* <img src="images/projekete-map.png" className="w-100" /> */}
                                    <MapComponent
                                        mode="neubau"
                                        activeTab={activeTab}
                                        activeSubTab={activeSubTab}
                                        markerColor={listColor}
                                    />
                                    {/* <MapComponent locationData={filteredData} /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NeubauProjekteTabs;